import Dinero from 'dinero.js';

export default function (value, format = '$0,0.00') {
    if (!value) {
        return '';
    }

    if (typeof value.toRoundedUnit === 'function') {
        return value.toFormat(format);
    }

    if (typeof value === 'string' || typeof value === 'number') {
        return new Dinero({
            amount: Math.round(Number.parseFloat(value.replace(/,/, '')) * 100),
        });
    }

    return new Dinero({
        amount: Number.parseInt(value.amount, 10),
        currency: value.currency,
    }).toFormat(format);
}
